import styled, { createGlobalStyle } from "styled-components";

const colors = {
  primary: "#0052CC",
  cardBackground: "#FFFFFF",
  textPrimary: "#172B4D",
  textSecondary: "#6B778C",
  border: "#DFE1E6",
  success: "#28a745",
  danger: "#dc3545",
  link: "#2563eb",
};

export const GlobalPopupStyles = createGlobalStyle`
  .custom-form-popup .dx-popup-title .dx-toolbar-label {
    white-space: normal !important;
    line-height: 1.4 !important;
    height: auto !important;
  }
`;

const BaseButton = styled.button`
  padding: 8px 18px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  background-color: #fff;
  &:focus {
    outline: none;
  }
`;

export const SaveButton = styled(BaseButton)`
  border: 2px solid ${colors.success};
  color: ${colors.success};
  &:hover {
    background-color: ${colors.success};
    color: #fff;
  }
`;

export const CancelButton = styled(BaseButton)`
  border: 2px solid ${colors.danger};
  color: ${colors.danger};
  margin-right: 12px;
  &:hover {
    background-color: ${colors.danger};
    color: #fff;
  }
`;

export const PopupFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 1rem;
  border-top: 1px solid #ddd;
  margin-top: 1rem;
`;

export const FormContainer = styled.div`
  padding: 1rem;
`;

export const NameLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  color: ${colors.link};
  font-weight: 600;
  cursor: pointer;
  text-align: left;

  &:hover {
    text-decoration: underline;
  }
`;

export const ProductHint = styled.p`
  margin: 8px 0 0;
  font-size: 13px;
  color: ${colors.textSecondary};
`;

export const ProductSection = styled.div`
  margin-top: 16px;
  max-height: 320px;
  overflow-y: auto;
  padding-right: 4px;
`;

export const ProductSectionHeader = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
`;

export const ProductSectionTitle = styled.h4`
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: ${colors.textPrimary};
`;

export const CapacityWarning = styled.p`
  margin: 10px 0 0;
  padding: 8px 10px;
  font-size: 12px;
  line-height: 1.4;
  color: #9a3412;
  background-color: #fff7ed;
  border: 1px solid #fdba74;
  border-radius: 6px;
`;

export const ProductRow = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 8px;
  align-items: start;
  margin-bottom: 10px;
`;

export const ProductRowFields = styled.div`
  min-width: 0;
`;

export const ProductRowHint = styled.p`
  margin: 4px 0 0;
  font-size: 12px;
  color: ${colors.textSecondary};
  min-height: 16px;
`;

export const EstatusBadge = styled.span<{ $active?: boolean }>`
  display: inline-block;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  color: #fff;
  background-color: ${({ $active }) => ($active ? "#16a34a" : "#71717a")};
  text-align: center;
  min-width: 72px;
`;
